export default __webpack_public_path__ + "static/media/vip-3.b08ab26d.svg";